<!--
 * @Autor        : sandyWqh
 * @Date         : 2023-01-31 16:39:23
 * @Description  : 
 * @Version      : 1.0
 * @LastEditors  : sandyWqh
 * @LastEditTime : 2023-02-06 14:15:35
-->
<template>
  <div class="r_nav">
    <div class="icon_box">
      <div style="display: none;" class="list-icon" @mouseenter="mouseenter('qq')" @mouseleave="mouseleave">
        <img :src="this.$path + '/assets/images/kefu.png'" class="img_icon" />
        <div class="list_box" ref="qq" style="top: 15px">
          <p>
            <span>{{ $t("langs.online_click") }}</span>
            <a target="_blank" @click="online_consult">{{
              $t("langs.online_services")
            }}</a>
          </p>
        </div>
      </div>
      <div class="list-icon" @mouseenter="mouseenter('wx')" @mouseleave="mouseleave">
        <img :src="this.$path + '/assets/images/weixin_icon.png'" class="img_icon" />
        <div class="list_box" ref="wx">
           <span style="display: block;margin-top: 11px;font-size: 13px;">{{
              $t("langs.weixinhot")
            }}</span>
          <img class="img" :src="this.$path + '/assets/images/aray_weixin.jpg'" />
        </div>
      </div>
      <div class="list-icon" @mouseenter="mouseenter('tel')" @mouseleave="mouseleave">
        <img :src="this.$path + '/assets/images/mobile_icon.png'" class="img_icon" />
        <div class="list_box" ref="tel">
          <p>
            <span style="display: block">{{
              $t("langs.hotline")
            }}</span>
            <span style="display: block">+86 18126287990</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hover",
  data() {
    return {};
  },
  methods: {
    mouseenter(target) {
      switch (target) {
        case "qq": {
          this.$refs["qq"].style = "display:block; top:28px";
          this.$refs["qq"].className = "list_box hover";
          break;
        }
        case "tel": {
          this.$refs.tel.style = "display:block;top:-60px";
          this.$refs.tel.className = "list_box hover";
          break;
        }
        case "wx": {
          this.$refs.wx.style = "display:block;top:28px";
          this.$refs.wx.className = "list_box hover";
          break;
        }
      }
    },
    mouseleave() {
      this.$refs.qq.style = "display:none";
      this.$refs.qq.className = "list_box";
      this.$refs.wx.style = "display:none";
      this.$refs.wx.className = "list_box";
      this.$refs.tel.style = "display:none";
      this.$refs.tel.className = "list_box";
    },
    //一洽 kefu 系统接入 js
    online_consult() {
      ECHAT.customOpenChat({
        chatWindowParam: {
          name: this.$t("langs.sitetitle"),
        },
        lan: this.$t("langs.args_lan"),
      });
    },
  },
  mounted() {
    //页面加载后执行一洽echat.js代码
    window._echat =
      window._echat ||
      function () {
        (_echat.q = _echat.q || []).push(arguments);
      };
    _echat.l = +new Date();
    _echat("initParam", { companyId: 381, echatTag: "website" });
    (function () {
      var echat = document.createElement("script");
      echat.type = "text/javascript";
      echat.async = true;
      echat.id = "echatmodulejs";
      echat.setAttribute("charset", "UTF-8");
      echat.src =
        ("https:" == document.location.protocol ? "https://" : "http://") +
        "www.echatsoft.com/visitor/echat.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(echat, s);
    })();
  },
};
</script>

<style scoped>
.r_nav {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #2a63a8;
  z-index: 999;
  width: 50px;
}

.icon_box {
  display: flex;
  flex-direction: column;
  height: 180px;
}

.list-icon {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  position: relative;
}
.list-icon:hover {
  background: #00dfb9;
  border: 1px solid #00dfb9;
  border-radius: 5px;
}
.list-icon .img_icon {
  width: 36px;
  height: 36px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.list_box {
  position: absolute;
  top: 0;
  right: 100%;
  background-color: #2a63a8;
  width: 120px;
  height: 120px;
  color: #fff;
  display: none;
  transform: all.5s;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.list-item {
  color: #fff;
  display: none;
}

.list_box p {
  font-size: 13px;
  line-height: 2em;
  padding: 10px 8px;
  text-align: center;
}

.list_box a {
  display: block;
  margin-top: 30px;
  width: 100px;
  height: 32px;
  line-height: 32px;
  color: #00dfb9;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
  border: 1px solid #00dfb9;
  border-radius: 5px;
  cursor: pointer;
}

.img {
  height: 74px !important;
  width: 74px !important;
  margin-top: 2px
}

.hover {
  animation: move 0.2s ease forwards;
}

@keyframes move {
  0% {
    width: 0;
  }

  100% {
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hover.vue